import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import './index.sass';

const { cnBlock, el } = bem('info');
export const Info = ({className, type = 'warning', children}) => {
    return (
        <div className={ cnBlock(className, type) }>
            <Icon name={ 'info' } />
            {children}
        </div>
    )
}
